export default function DataDeletion() {
  return (
    <div style={{maxWidth:700,margin:'60px auto',padding:'0 24px',fontFamily:'Inter,sans-serif',color:'#1e293b'}}>
      <h1 style={{fontSize:32,fontWeight:900,marginBottom:8}}>Eliminación de Datos</h1>
      <p style={{color:'#64748b',marginBottom:32}}>Última actualización: 27 de abril de 2026</p>

      <section style={{marginBottom:32}}>
        <h2 style={{fontSize:20,fontWeight:700,marginBottom:12}}>¿Cómo solicitar la eliminación de tus datos?</h2>
        <p style={{lineHeight:1.7,color:'#475569'}}>Si conectaste tu cuenta de Facebook/Meta a AdPulse AI y deseas que eliminemos todos tus datos, puedes hacerlo de las siguientes formas:</p>
      </section>

      <section style={{marginBottom:32,background:'#f8fafc',borderRadius:12,padding:24,border:'1px solid #e2e8f0'}}>
        <h3 style={{fontSize:16,fontWeight:700,marginBottom:12}}>Opción 1: Desde Facebook</h3>
        <ol style={{lineHeight:2,color:'#475569',paddingLeft:20}}>
          <li>Ve a <strong>Configuración de Facebook</strong></li>
          <li>Clic en <strong>Aplicaciones y sitios web</strong></li>
          <li>Busca <strong>AdPulse AI</strong> y haz clic en <strong>Eliminar</strong></li>
          <li>Confirma la eliminación</li>
        </ol>
      </section>

      <section style={{marginBottom:32,background:'#f8fafc',borderRadius:12,padding:24,border:'1px solid #e2e8f0'}}>
        <h3 style={{fontSize:16,fontWeight:700,marginBottom:12}}>Opción 2: Contacto directo</h3>
        <p style={{lineHeight:1.7,color:'#475569'}}>Envía un correo a <a href="mailto:sebastian.mellado.cl@gmail.com" style={{color:'#1a56db'}}>sebastian.mellado.cl@gmail.com</a> con el asunto <strong>"Eliminación de datos"</strong> indicando tu nombre y correo asociado.</p>
        <p style={{lineHeight:1.7,color:'#475569',marginTop:8}}>Procesaremos tu solicitud en un plazo máximo de <strong>30 días hábiles</strong>.</p>
      </section>

      <section style={{marginBottom:32}}>
        <h2 style={{fontSize:20,fontWeight:700,marginBottom:12}}>¿Qué datos eliminamos?</h2>
        <ul style={{lineHeight:2,color:'#475569',paddingLeft:20}}>
          <li>Tokens de acceso a Meta/Facebook</li>
          <li>Datos de campañas publicitarias sincronizados</li>
          <li>Métricas e historial de rendimiento</li>
          <li>Información de cuenta y perfil</li>
        </ul>
      </section>

      <section>
        <h2 style={{fontSize:20,fontWeight:700,marginBottom:12}}>Contacto</h2>
        <p style={{lineHeight:1.7,color:'#475569'}}>Para cualquier consulta sobre privacidad y datos: <a href="mailto:sebastian.mellado.cl@gmail.com" style={{color:'#1a56db'}}>sebastian.mellado.cl@gmail.com</a></p>
      </section>
    </div>
  );
}
